import ExcelJS from "exceljs";

export async function exportToExcel(data, filename = "informe.xlsx") {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Informe de Seguimiento");

  worksheet.columns = [
    { header: "Proyecto", key: "proyecto", width: 35 },
    { header: "Fecha", key: "fecha", width: 15 },
    { header: "Día", key: "dia", width: 10 },
    { header: "Mes", key: "mes", width: 10 },
    { header: "Año", key: "anio", width: 12 },
    { header: "Acompañamiento", key: "acompanamiento", width: 18 },
    { header: "Capacitación", key: "capacitacion", width: 18 },
    { header: "Archivo", key: "archivo", width: 70 },
  ];

  // Estilos encabezados
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1E293B" },
    };
    cell.alignment = { horizontal: "center", vertical: "middle" };
  });

  // Datos
  data.forEach((item) => {
    const fechaBonita = `${item.dia}/${item.mes}/${item.anio}`;

    worksheet.addRow({
      proyecto: item.proyecto,
      fecha: fechaBonita,
      dia: item.dia,
      mes: item.mes,
      anio: item.anio,
      acompanamiento: item.acompanamiento === "X" ? 1 : 0,
      capacitacion: item.capacitacion === "X" ? 1 : 0,
      archivo: item.archivo,
    });
  });

  // Bordes
  worksheet.eachRow((row, rowIndex) => {
    if (rowIndex !== 1) {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    }
  });

  // 🔥 Totalizadores reales
  const totalAcompanamiento = data.filter((i) => i.acompanamiento === "X").length;
  const totalCapacitacion = data.filter((i) => i.capacitacion === "X").length;

  // Insertar espacio antes del totalizador
  worksheet.addRow([]);

  // 🔵 Fila total acompañamiento
  const totalRow1 = worksheet.addRow([
    "Total Acompañamiento:",
    totalAcompanamiento
  ]);

  // 🔵 Fila total capacitación
  const totalRow2 = worksheet.addRow([
    "Total Capacitación:",
    totalCapacitacion
  ]);

  // Estilo totalizador
  [totalRow1, totalRow2].forEach((row) => {
    row.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE2E8F0" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Exportar
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}
